import * as React from "react";
import { useState } from "react";
import {
  makeStyles,
  shorthands,
  Textarea,
  Button,
  Tooltip,
} from "@fluentui/react-components";
import { SendRegular } from "@fluentui/react-icons";

// --- Estilos ---
const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "flex-end",
    width: "100%",
    ...shorthands.padding("10px"),
    ...shorthands.borderTop("1px", "solid", "#e0e0e0"),
    backgroundColor: "#ffffff",
    gap: "10px",
    boxSizing: "border-box",
  },
  textarea: {
    flexGrow: 1,
    maxHeight: "100px",
  },
  sendButton: {
    flexShrink: 0,
  },
});

// --- Props Interface ---
export interface ChatInputAreaProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
}

// --- Component ChatInputArea ---
const ChatInputArea: React.FC<ChatInputAreaProps> = ({ onSendMessage, isLoading }) => {
  const styles = useStyles();
  const [message, setMessage] = useState("");

  const handleSend = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage && !isLoading) {
      onSendMessage(trimmedMessage);
      setMessage(""); // Clear input after sending
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={styles.container}>
      <Textarea
        className={styles.textarea}
        value={message}
        onChange={(_e, data) => setMessage(data.value)}
        onKeyDown={handleKeyDown}
        placeholder="Escribe tu mensaje aquí..."
        disabled={isLoading}
        resize="vertical"
      />
       <Tooltip content="Enviar mensaje" relationship="label">
        <Button
            appearance="primary"
            icon={<SendRegular />}
            onClick={handleSend}
            disabled={isLoading || !message.trim()}
            className={styles.sendButton}
            aria-label="Enviar mensaje"
        />
       </Tooltip>
    </div>
  );
};

export default ChatInputArea;
